import { useDecision } from '@optimizely/react-sdk';

const FEATURE_FLAG_NAME = 'qantas-hotels-expt_3-full_points_earnt_on_bookings';
const VARIATION_KEY = 'show_full_points';

type Result = {
  isReady: boolean;
  showFullPoints: boolean;
};

const useShowFullPointsToggle = (): Result => {
  const [decision, isReady] = useDecision(FEATURE_FLAG_NAME, { autoUpdate: true });

  return {
    isReady,
    showFullPoints: decision.enabled && decision.variationKey === VARIATION_KEY,
  };
};

export default useShowFullPointsToggle;
